import { render, staticRenderFns } from "./ModalDirectMail.vue?vue&type=template&id=10a38a52&"
import script from "./ModalDirectMail.vue?vue&type=script&lang=js&"
export * from "./ModalDirectMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports